export default function ButtonLoader({ label = "در حال انجام", className = "" }) {
  return (
    <span role="status" aria-label={label} className={`zi-button-loader ${className}`}>
      {Array.from({ length: 8 }).map((_, index) => <span key={index} />)}
    </span>
  );
}
